import { MultilingualField } from '../types/localization';
import { Language } from '../types/localization';

export const getLocalizedValue = <T = string>(
  field: MultilingualField<T> | T | undefined,
  language: Language
): T | string => {
  if (!field) return '' as unknown as T;
  
  // If it's not a multilingual field, return as is
  if (typeof field !== 'object' || !('en' in field)) {
    return field as T;
  }
  
  // If it's a multilingual field
  const multiField = field as MultilingualField<T>;
  
  // Return the requested language if available, otherwise fallback to English
  if (language === 'ar' && multiField.ar) {
    return multiField.ar;
  }
  
  return multiField.en;
};

export const createMultilingualField = <T = string>(
  enValue: T,
  arValue?: T
): MultilingualField<T> => {
  return {
    en: enValue,
    ar: arValue,
  };
};